import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  xlsx: any;

  async loadXLSX(): Promise<any> {
    if (!this.xlsx) {
      this.xlsx = await import('xlsx');
    }
    return this.xlsx;
  }

  async exportToExcel(data: any[], fileName: string, headers: string[] | null = null): Promise<void> {
    try {
      const XLSX = await this.loadXLSX();

      const worksheet = XLSX.utils.json_to_sheet(data);

      if (headers) {
        XLSX.utils.sheet_add_aoa(worksheet, [headers]);
      }

      this.autoFitColumns(worksheet, data, headers);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      await XLSX.writeFile(workbook, `${fileName}.xlsx`);
    } catch (error) {
      console.error('Ошибка при загрузке библиотеки xlsx или экспорте:', error);
    }
  }

  autoFitColumns(
    worksheet,
    data: any[],
    headers: string[] | null = null
  ) {
    const jsonKeys = headers ?? Object.keys(data[0] ?? {});
    const colWidths = jsonKeys.map(key => key.length);

    for (const row of data) {
      const rowValues = Object.values(row);
      jsonKeys.forEach((_, index) => {
        colWidths[index] = Math.max(colWidths[index], this.getCellLength(rowValues[index]));
      });
    }

    // Добавляем небольшой запас (2-3 символа)
    worksheet['!cols'] = colWidths.map(width => ({
      wch: Math.min(width + 2, 100)
    }));

    return worksheet;
  }

  getCellLength(value: unknown): number {
    if (value === null || value === undefined) {
      return 0;
    }

    return String(value).length;
  }
}
